import config from "./config/app";
import aerial from "./images/aerial.png";
import netzkarte from "./images/netzkarte.png";
import { RoutingService, STYLE_REVIEW_PREFIX } from "./utils/constants";

import type { EnvStateByDomain } from "./envConfig";

const state: EnvStateByDomain = {
  app: {
    config: config as EnvStateByDomain["app"]["config"],
    defaultLang: "en",
    exportLayoutsDefaultOrg: "app",
    globalIcons: undefined, // No global icons for app
    hideSbbCopyright: true,
    languageOptions: [
      { child: "Deutsch", id: "de", value: "de-DE" },
      { child: "Français", id: "fr", value: "fr" },
      { child: "Italiano", id: "it", value: "it" },
      { child: "English", id: "en", value: "en" },
    ],
    prefAgencies: "db",
    routingBarrierFree: false,
    routingDefaultMot: "car",
    routingMaxNbViaPoints: 5,
    routingMots: ["car", "bike", "foot"],
    routingService: RoutingService.Graphhopper,
    ssoClientId: "991094",
    useGeneralizedRouting: false,
  },
  map: {
    center: [949653.65, 6803851.06],
    defaultBaseLayers: [
      {
        key: "world.geops.colorful",
        name: "colorful",
        // style: `versatiles.colorful`,
        style: `${STYLE_REVIEW_PREFIX}basemap_bright`,
        thumbnail: netzkarte,
      },
      {
        key: "world.geops.neutrino",
        name: "neutrino",
        // style: `versatiles.neutrino`,
        style: `${STYLE_REVIEW_PREFIX}basemap_dark`,
        thumbnail: netzkarte,
      },
      {
        key: "world.geops.aerial",
        name: "aerial",
        // style: `versatiles.aerial`,
        style: `${STYLE_REVIEW_PREFIX}basemap_aerial`,
        thumbnail: aerial,
      },
    ],
  },
};
export default state;
